<template>
  <div>
          <div class="centerx">
      <vs-popup class="holamundo"  v-bind:title="'Ajuda - Cadastro de estacionamento'" :active.sync="popupActivo">
          <div v-html="textoAjuda">
            
          </div>
      </vs-popup>
    </div>    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro de estacionamento</h4>
         <div class="badge bagde-default"
      @click="popupActivo =true"
       style="position:absolute; top:17px; right:15px;">Ajuda <i class="fa fa-question-circle"></i></div>

    </div>
    <div class="card">
      <form style="padding:15px;" autocomplete="off"> 
        <h4 class="mb-3">Dados do estacionamento</h4>
        <div class="form-row">
        <div class="form-group col-md-4">
           <label for="_form-areaTotal">Área total</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.arealTotal"
              id="_form-areaTotal"
              required
           />
        </div>
        <div class="form-group col-md-3">
           <label for="_form-areaUtil">Área útil</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.areaUtil"
              id="_form-areaUtil"
              required
           />
        </div>
        <div class="form-group col-md-5">
           <label for="_form-areaUtil">Capacidade de guardar veículos</label>
           <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.capacidadeGuardaVeiculo"
              id="_form-areaUtil"
              required
           />
        </div>
        <div class="form-group col-md-12">
            <label for="_form-endereco">Endereço</label>
          <input
            type="text"
            class="form-control"
            v-model="cadastro.endereco"
            id="_form-Logradouro"
            required
            maxlength="100"
          />
        </div>
          <div class="form-group col-md-12">
            <label for="_form-link">Link Google Maps</label>
            <textarea class="form-control" id="_form-link" v-model="cadastro.linkGoogleMaps"></textarea>
          </div>
         <div class="col-md-2 form-group">
          <label>Alugado:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': cadastro.alugado == true}"
            >
              <input type="radio" name="ativo" id="ativo" @click="mudaAlugado(true)"   autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': cadastro.alugado == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @click="mudaAlugado(false)"   autocomplete="off" class="valid" /> Não
            </label>
          </div>

        </div>
         <div class="form-group col-md-12">
            <label for="_form-proprietario">Proprietário</label>
          <input
            type="text"
            class="form-control"
            v-model="cadastro.proprietario"
            id="_form-proprietario"
            required
            maxlength="100"
          />
        </div>
        <div class="form-group col-md-12">
            <label for="_form-tipoContrato " class="mb-1">Tipo de contrato</label>
            <p class="mb-1 small help">Se nome do proprietário diferente do nome da empresa e dos sócios informar tipo de contrato</p>
          <input
            type="text"
            class="form-control"
            v-model="cadastro.tipoContrato"
            id="_form-tipoContrato"
            required
            maxlength="100"
          />
        </div>
        <div class="form-group col-md-4">
           <label for="_form-mercadoImovel">Valor do mercado do imóvel</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorMercadoImovel"
              id="_form-mercadoImovel"
              required
              separator="."
              currency="R$"
           />

          </div>
           <div class="form-group col-md-5">
           <label for="_form-iAluguel">Valor do mercado do aluguel do imóvel</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorMercadoImovelAluguel"
              id="_form-iAluguel"
              required
              separator="."
              currency="R$"
           />

          </div>
           <div class="form-group col-md-3">
           <label for="_form-valorCondominio">Valor do condomínio</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorCondominio"
              id="_form-valorCondominio"
              required
              separator="."
              currency="R$"
           />

          </div>
           <div class="form-group col-md-4">
           <label for="_form-vAluguel">Valor do aluguel (se pago)</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorAluguel"
              id="_form-vAluguel"
              required
              separator="."
              currency="R$"
           />

          </div>
          <div class="col-sm-12"></div>
         <div class="col-md-6 form-group">
          <label>Segurança:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': cadastro.seguranca == true}"
            >
              <input type="radio" name="ativo" id="ativo" @click="mudaSeguranca(true)"   autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': cadastro.seguranca == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @click="mudaSeguranca(false)"   autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
           <div class="form-group col-md-6">
           <label for="_form-segurancaCusto">Custo segurança</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.segurancaCusto"
              id="_form-segurancaCusto"
              required
              separator="."
              currency="R$"
           />

          </div>
         <div class="col-md-6 form-group">
          <label>Equipamentos para movimentação dos veículos:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': cadastro.equipamentosMovimentacao == true}"
            >
              <input type="radio" name="ativo" id="ativo" @click="mudaEquipamentos(true)"   autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': cadastro.equipamentosMovimentacao == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @click="mudaEquipamentos(false)"   autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
           <div class="form-group col-md-6">
           <label for="_form-equipamentosMovimentacaoCusto">Valor dos equipamentos</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.equipamentosMovimentacaoValor"
              id="_form-equipamentosMovimentacaoCusto"
              required
              separator="."
              currency="R$"
           />

          </div>
         <div class="col-md-6 form-group">
          <label>Seguro:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': cadastro.seguro == true}"
            >
              <input type="radio" name="ativo" id="ativo" @click="mudaSeguo(true)"   autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': cadastro.seguro == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @click="mudaSeguo(false)"   autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
           <div class="form-group col-md-6">
           <label for="_form-seguroPremio">Custo do seguro</label>
           <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.seguroPremio"
              id="_form-SeguroPremio"
              required
              separator="."
              currency="R$"
           />
          </div>

           <div class="form-group col-md-8">
           <label for="_form-tempoMedioPatioOficina">Tempo médio (em minutos) para movimentar o veículo no pátio e levar à oficina</label>
           <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.tempoMedioPatioOficina"
              id="_form-tempoMedioPatioOficina"
              required
              style="width:100px"
           />
          </div>


       </div>
          <div style="display: flex; jusify-content:flex-end">
            <button class="btn btn-primary ml-auto" @click.prevent="fnCadastra">Salvar</button>
          </div>

      </form>
    </div>
  </div>
</template>

<script>
  import { getSuccess } from "../../../global/utils";

  export default {
    data() {
      return {
        cadastro:{
          alugado:false,
          seguranca:false,
          seguro:false,
          equipamentosMovimentacao:false,

       }, 
        servico: null,
        textoAjuda: null,
        popupActivo:false,
      }
    },
    mounted() {
      this.fnGetContratacao()
    },
    methods: {
    async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_04`)
        .then((res) => {
          console.log(res.data.contratacaoId);
          this.cadastro.contratacaoId = res.data.contratacaoId;
          if(res.data.contratacoesEVO04 != null){
            this.cadastro = res.data.contratacoesEVO04
          }
        })
        .catch(() => {});
          await this.$http.get(`contratacao/lista/${this.$route.params.codigoContrato}`)
            .then(res=>{
                this.servico = res.data.servicos
                this.textoAjuda =  this.servico.textoAjuda04;

        })

    },
      
      mudaAlugado(val){
        if(this.cadastro.alugado != val ){this.cadastro.alugado =!this.cadastro.alugado}
      },
      mudaSeguranca(val){
        if(this.cadastro.seguranca != val ){this.cadastro.seguranca =!this.cadastro.seguranca}
      },
      mudaEquipamentos(val){
        if(this.cadastro.equipamentosMovimentacao != val ){this.cadastro.equipamentosMovimentacao =!this.cadastro.equipamentosMovimentacao}
      },
      mudaSeguo(val){
        if(this.cadastro.seguro != val ){this.cadastro.seguro =!this.cadastro.seguro}
      },
      async fnCadastra(e) {
        e.preventDefault();
        const metodo = this.cadastro.etapaId ? "put" : "post";
        this.cadastro.tsAlteracao = this.cadastro.etapaId
          ? this.$moment().format()
          : null;
        const completaUrl = this.cadastro.etapaId
          ? "/" + this.cadastro.etapaId
          : "";
        await this.$http[metodo]("/etapa_04" + completaUrl, this.cadastro)
          .then((res) => {
            if ( metodo == "post"){this.cadastro = res.data} 
            getSuccess();
          })
          .catch(() => {});
      },    

    },
  }
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
</style>